import { API_URL } from "./config";
export class Utils {
    static downloadText(text, fileName) {
        const file = new Blob(['\uFEFF' + text], { type: 'text/plain' });
        const a = document.createElement("a");
        a.download = fileName;
        a.href = URL.createObjectURL(file);
        a.click();
    }
    static extractText(html) {
        //uses span to avoid things like &nbsp;
        const span = document.createElement('span');
        span.innerHTML = html.replace(/<[^>]+>/g, ' ').replace(/ +/g, ' ');
        return span.innerText.replace(/[\r\n]/g, "");
    }
    ;
    static flatMap(array, map) {
        const result = [];
        for (let a of array)
            result.push(...map(a));
        return result;
    }
    static chooseTranslation(value) {
        if (!value)
            return "";
        if (value[lang])
            return value[lang];
        if (value["00"])
            return value["00"];
        if (value.en)
            return value.en;
        const keys = Object.keys(value);
        if (keys.length > 0)
            return value[keys[0]];
        return "";
    }
    static async get(api) {
        const response = await fetch(`${API_URL}${api}`, {
            "method": "GET",
            "headers": {
                "Accept": "application/json"
            }
        }).catch(err => {
            console.error(err);
        });
        if (!response)
            return null;
        return await response.json();
    }
    static urlify(website) {
        if (website == null)
            return "";
        else if (website.startsWith("http://") || website.startsWith("https://"))
            return website;
        else
            return "https://" + website;
    }
}
